import { CustomerAddressDetails } from '@domgen/dgx-fe-common';
import { WorldpayTransactionSource } from './worldpay-transaction-source.enum';
import { WorldpayTransactionType } from './worldpay-transaction-type.enum';

export interface WorldpayRedirectRequest {
  address?: CustomerAddressDetails;
  amount: number;
  billingAddress: CustomerAddressDetails;
  companyCode: string;
  currency?: string;
  description: string;
  email: string;
  name: string;
  referenceNumber?: string;
  schemeCode: string;
  transactionSource: WorldpayTransactionSource;
  transactionType: WorldpayTransactionType;
}
